import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
// -*- mode: jsx;-*-
import PureRenderMixin from './external-adapters/pureRenderMixinAdapter.js';

import { LocationSearchBox } from './locationSearchBox.js';
import { KeywordSearchBox } from './KeywordSearchBox.js';
import { closeiOSKeyboard } from '../utils/iOS.js';

export const SearchBoxes = createReactClass({
    propTypes: {
        searchURL: PropTypes.string.isRequired,
        baseSearchURL: PropTypes.string.isRequired,
        callbacks: PropTypes.objectOf(PropTypes.func).isRequired,

        detectedLocation: PropTypes.object,
        filterCategories: PropTypes.array,
        extraFilters: PropTypes.array,
        projects: PropTypes.object,
        showBrowseLink: PropTypes.bool,
        placeholder: PropTypes.string,
    },

    mixins: [PureRenderMixin],

    browseLink: function () {
        if (!this.props.showBrowseLink) {
            return '';
        } else {
            return (
                <a className="browse-funded" href={this.props.baseSearchURL + '?historical=true&featured=true'}>Browse A+ Projects</a>
            );
        }
    },

    /**
     * Trigger searches on all boxes in this "form"
     */
    search: function () {
        closeiOSKeyboard();
        dcAnalytics.trackOptX('submitsearch');
        const keywordsURL = this.makeKeywordsURL();
        this.refs.location.submit(keywordsURL);
    },

    makeKeywordsURL: function () {
        return this.refs.keywords.makeURL(false, false);
    },

    render: function () {
        const props = this.props;
        return (
            <div className="form-redux search-area">
                <KeywordSearchBox {...props} searchAll={this.search} ref="keywords" />
                <LocationSearchBox {...props} searchAll={this.search}
                    makeKeywordsURL={this.makeKeywordsURL} ref="location" />
                <div tabIndex="0" role="button" className="button-secondary js-click-on-enter" onClick={this.search}>
                    Search
                </div>
                {this.browseLink()}
            </div>
        );
    },
});
